<template>
  <div class="it">
    <div class="lock-sticky">
      <b-container fluid>
        <div
          :class="['sidebar-right', { 'slide-right': show }, {
                'disable-side-btn': disable,
              },]"
          @mouseenter="show = true"
          @mouseleave="show = false"
        >
          <b-row>
            <b-col class="text-black"
              ><strong>Select<span v-show="!show">:</span></strong
              ><span v-show="show"> your account:</span></b-col
            >
          </b-row>
          <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal',
              { 'active-row-right': activeProductType == 'Suite' },
            ]"
            @click="accountType('Suite')"
          >
            <b-col md="4" class="image-change my-auto">
              <img
                src="@/assets/images/icons/Account-Suite-Gradient.svg"
                class="image-side-bars smallen-side-image"
                 v-show="activeProductType == 'Suite'"
              />
              <img
                src="@/assets/images/icons/Account-Suite-Grey.svg"
                class="image-side-bars smallen-side-image"
                 v-show="activeProductType != 'Suite'"
              />

            </b-col>
            <b-col md="8" v-show="show" class="my-auto side-bar-text-size">
              <h5 class="pb-0 mb-0">Full banking suite</h5>
              <p></p>
            </b-col>
          </b-row>
          <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal',
              { 'active-row-right': activeProductType == 'Card Account' },
              {
                'disable-side-btn': disable,
              },
            ]"
            @click="accountType('Card Account')"
          >
            <b-col md="4" class="pl-4 image-change my-auto">
              <img
                src="@/assets/images/icons/Account-Credit-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Card Account'"
              />
              <img
                src="@/assets/images/icons/Account-Credit-Grey.svg"
                class="image-side-bars smallen-side-image"
                 v-show="activeProductType != 'Card Account'"
              />
            </b-col>
            <b-col md="8" v-show="show" :class="['side-bar-text-size',{'gray-out':disable}]">
              <h5 class="pb-0 mb-0">Credit card</h5>
              <p>account</p>
            </b-col>
          </b-row>
           <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal',
              {
                'active-row-right':
                  activeProductType ==
                  'Transaction Account (bundled fees)',
              },
              {
                'disable-side-btn': disable,
              },
            ]"
            @click="
              accountType('Transaction Account (bundled fees)')
            "
          >
            <b-col md="4" class="image-change my-auto">
              <img
                src="@/assets/images/icons/Account-Transaction-Bundled-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Transaction Account (bundled fees)'"
              />
              <img
                src="@/assets/images/icons/Account-Transaction-Bundled-Grey.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType != 'Transaction Account (bundled fees)'"
              />
            </b-col>
            <b-col md="8" v-show="show" :class="['side-bar-text-size',{'gray-out':disable}]">
              <h5 class="pb-0 mb-0">Transaction</h5>
              <p>with bundled fees</p>
            </b-col>
          </b-row>
         <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal',
              {
                'active-row-right':
                  activeProductType == 'Transaction Account (pay-as-you-transact fees)',
              },
              {
                'disable-side-btn': disable,
              },
            ]"
            @click="accountType('Transaction Account (pay-as-you-transact fees)')"
          >
            <b-col md="4" class="image-change my-auto">
              <img
                src="@/assets/images/icons/Account-Transaction-Gradient.svg"
                class="image-side-bars smallen-side-image"
                 v-show="activeProductType == 'Transaction Account (pay-as-you-transact fees)'"
              />
              <img
                src="@/assets/images/icons/Account-Transaction-Grey.svg"
                class="image-side-bars smallen-side-image"
                 v-show="activeProductType != 'Transaction Account (pay-as-you-transact fees)'"
              />
            </b-col>
            <b-col md="8" v-show="show" :class="['side-bar-text-size',{'gray-out':disable}]">
              <h5 class="pb-0 mb-0">Transaction</h5>
              <p>with pay-as-you-transact fees</p>
            </b-col>
          </b-row>
        </div>
        <div
         
          :class="['item-test right-side-style-cust', { 'side-right': show }]"
          @mouseenter="show = true"
          @mouseleave="show = false"
        >
          <b-container fluid :class="['sidebar-other pl-4 mt-2 padding-2-add-right text-white smallen-font',healthMemberAct=='yes'?'blue-bg':'grey-bg']">
            <b-row>
              <b-col md="3" class="p-3">
                <img
                  src="@/assets/images/icons/running_man.svg"
                  alt=""
                  srcset=""
                  class="image-side-bars smallen-side-image"
                />
              </b-col>
              <b-col md="9" v-show="show">
                <p class="smallen-font margin-bottom-removal pt-1 text-center">Are you a <strong>Vitality <br> Health </strong>member?</p>
                <div class="inline-radio pb-1">
                  <b-form-radio
                    v-model="healthMemberAct"
                    value="yes"
                    class="radio-blue"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="healthMemberAct"
                    value="no"
                    class="radio-blue"
                    >No</b-form-radio
                  >
                </div>
              </b-col>
            </b-row>
          </b-container>

          <b-container fluid :class="['sidebar-other mt-1 padding-2-add-right text-white smallen-font',driveMemberAct=='yes'?'purple-bg':'grey-bg']">
            <b-row>
              <b-col md="3" class="p-3">
                <img
                  src="@/assets/images/icons/car.svg"
                  alt=""
                  class="image-side-bars smallen-side-image"
                />
              </b-col>
              <b-col md="9" v-show="show">
                <p class="smallen-font margin-bottom-removal text-center">Are you a <strong>Vitality <br> Drive </strong>member?</p>
                <div class="inline-radio pb-1">
                  <b-form-radio
                    v-model="driveMemberAct"
                    value="yes"
                    class="radio-purple"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="driveMemberAct"
                    value="no"
                    class="radio-purple"
                    >No</b-form-radio
                  >
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    driveMemberActive: {
      default: "yes",
    },
    healthMemberActive: {
      default: "yes",
    },
    activeProductType: {
      default: "Suite",
    },
    disable: {
      default: false,
    },
  },
  data() {
    return {
      show: false,
      driveMemberAct: this.driveMemberActive,
      healthMemberAct: this.healthMemberActive,
    };
  },
  methods: {
    driveMember(item) {},
    accountType(item) {
      if (this.disable != true) {
        this.$emit("account", item);
      }
    },
    healthMember(item) {
      this.$emit("health", item);
    },
  },
  watch: {
    driveMemberAct() {
      if (this.driveMemberAct == "yes") {
        this.$emit("drive", "yes");
      } else {
        this.$emit("drive", "no");
      }
    },
    healthMemberAct() {
      if (this.healthMemberAct == "yes") {
        this.$emit("health", "yes");
      } else {
        this.$emit("health", "no");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-right {
  cursor: pointer;
  position: absolute;
  right: -6em;
  padding: 1em;
  color: black;
  background-color: white;
}

.slide-right {
  width: 18em;

  z-index: 6;
}
.side-right {
  width: 18em;
}
.row-setting {
   height: 4em;
  .image-change {
    filter: opacity(0.5);
  }
}
.item-test {
  position: absolute;
  right: -6rem;
}
.resize-padding {
  padding: 1.8em;
}
.it {
  position: absolute;
  right: 8rem;
}
@media only screen and (min-width: 1200px) {
  .only-display-on-largest-screen {
    display: block !important;

  }
  @media only screen and (max-width:1590px) {
    
      .sidebar-right {
        right: -6.85em !important;
      }
      .item-test{
        right: -6.7rem !important;
      }
  }

}
 @media only screen and (max-height:730px) {
    .lock-sticky {
      position: fixed;
      top:8em;
      z-index: 8;
    }
  }

  @media only screen and (max-height:540px) {
  .lock-sticky {
    position: relative;
    top:8em;
    z-index: 8;
  }

  .it {
    position: relative;
    right: 0;
  }
}
</style>